module.exports = __webpack_public_path__ + "img/1.45f05131.jpg";